import React from "react";
import styles from "./ConfirmBookingDetails.module.scss";
import { useNavigate } from "react-router-dom";
import {
    PatientsIcon,
    CalenderIcon,
    CloseIcon,
    UserProfileIcon,
} from "../icons/icons";
import styled from "styled-components";

export const IconContainer = styled.div`
    width: 40px;
    height: 40px;
    gap: 8px;
    border-radius: 12px;
    border-width: 1px;
    border: 1px solid #eeeeee;
    padding: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
`;

const ConfirmBookingDetails = ({
    patient = "Andrew Scone",
    provider = "Dr Ethel Boykin",
    date = "Mon, 27th April, 2025",
    time = "8:00am - 9:00am",
    location = "AOA Clinic",
    onBack,
}) => {
    const navigate = useNavigate();

    const handleBook = () => {
        navigate("/appointments", { state: { tab: "AVAILABILITY" } });
        window.location.reload(); // <-- manually forces reload AFTER navigatin
    };

    return (
        <div className={styles.modalOverlay}>
            <div className={styles.confirmContainer}>
                <div className={styles.headerRow}>
                    <div>
                        <h2 className={styles.title}>Review Booking</h2>
                        <p className={styles.subtitle}>
                            Confirm booking details
                        </p>
                    </div>
                    <CloseIcon className={styles.closeIcon} onClick={onBack} />
                </div>
                <div className={styles.detailsGrid}>
                    <div className={styles.detailItem}>
                        <IconContainer>
                            <UserProfileIcon />
                        </IconContainer>
                        <div>
                            <div className={styles.label}>Patient</div>
                            <div className={styles.value}>Andrew Scone</div>
                        </div>
                    </div>
                    <div className={styles.detailItem}>
                        <IconContainer>
                            <UserProfileIcon />
                        </IconContainer>
                        <div>
                            <div className={styles.label}>Provider</div>
                            <div className={styles.value}>Dr Ethel Boykin</div>
                        </div>
                    </div>
                    <div className={styles.detailItem}>
                        <IconContainer>
                            <CalenderIcon color="#6A421C" />
                        </IconContainer>
                        <div>
                            <div className={styles.label}>Date</div>
                            <div className={styles.value}>
                                Mon, 27th April, 2025
                            </div>
                        </div>
                    </div>
                    <div className={styles.detailItem}>
                        <IconContainer>
                            <CalenderIcon color="#6A421C" />
                        </IconContainer>
                        <div>
                            <div className={styles.label}>Time</div>
                            <div className={styles.value}>8:00am -9:00am</div>
                        </div>
                    </div>
                    <div
                        className={styles.detailItem}
                        style={{ gridColumn: "1 / span 2" }}
                    >
                        <IconContainer>
                            <CalenderIcon color="#6A421C" />
                        </IconContainer>
                        <div>
                            <div className={styles.label}>
                                Practice Location
                            </div>
                            <div className={styles.value}>AOA Clinic</div>
                        </div>
                    </div>
                </div>
                <div className={styles.buttonRow}>
                    <button className={styles.backButton} onClick={onBack}>
                        Back
                    </button>
                    <button className={styles.bookButton} onClick={handleBook}>
                        Book Session
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmBookingDetails;
